import { useEffect, useState } from "react";
import axios from "axios";
import { Container, Card, Form, Button, Alert, InputGroup, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/LogoFull.png";
import "./design/Login.css";
import { useNavigate } from "react-router-dom";
import { useRole } from "../RoleContext.js";

axios.defaults.withCredentials = true;

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);

    const navigate = useNavigate();
    const { login } = useRole();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            login(token); // Llamar la función de autenticación
        }
    }, []);

    const validarUsername = (username) => {
        const rutRegex = /^[0-9]{7,8}[0-9K]$/;
        return rutRegex.test(username);
    };

    const validarPassword = (password) => {
        const contraseñaRegex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,}$/;
        return contraseñaRegex.test(password);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!username || !password) {
            setMessage("Por favor, completa todos los campos.");
            return;
        }
        if (!validarUsername(username)) {
            alert("El RUT debe tener entre 7 y 9 dígitos sin puntos ni guion.");
            return;
        }
        if (!validarPassword(password)) {
            alert("La contraseña debe ser alfanumérica y tener al menos 6 caracteres.");
            return;
        }

        setLoading(true);
        setMessage("");

        try {
            const response = await axios.post("https://socios.kolpingchile.cl/backend/login", { username, password }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                withCredentials: true,  // si quieres enviar cookies, para el token en cookie httpOnly
            });

            if (response.data.token) {
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("nombreUsuario", response.data.nombre); // Guardar el nombre del usuario
                setMessage("¡Inicio de sesión exitoso!");
                navigate("/inicio");
                window.location.reload(); // Redirigir a la página de inicio
                login(response.data.token);
            } else {
                setMessage("Error: El servidor no devolvió un token.");
            }
        } catch (error) {
            setMessage(error.response?.data?.message || "Usuario o contraseña incorrecta");
        } finally {
            setLoading(false);
        }
    };
    const openForgotPasswordModal = () => {
        setShowForgotPasswordModal(true);
    };
    const closeForgotPasswordModal = () => {
        setShowForgotPasswordModal(false);
    }



    return (
        <Container className="login-container">
            <Card className="login-card">
                <Card.Body>
                    <img src={logo} alt="Kolping Chile" className="login-logo" />
                    <h3 className="text-center mb-4">INICIAR SESIÓN</h3>
                    <Form onSubmit={handleLogin}>
                        {message && <Alert variant="danger">{message}</Alert>}
                        <Form.Group className="mb-3">
                            <Form.Label>Usuario</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="RUT (sin puntos ni guión)"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                disabled={loading}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Contraseña</Form.Label>
                            <InputGroup className="">
                                <Form.Control
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Contraseña"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    disabled={loading}
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setShowPassword(!showPassword)}
                                    disabled={loading}
                                >
                                    {showPassword ? <FontAwesomeIcon icon={faEye} size="lg" /> :
                                        <FontAwesomeIcon icon={faEyeSlash} size="lg" />}
                                </Button>
                            </InputGroup>
                            <Button variant="link" onClick={() => openForgotPasswordModal()} >¿Olvidaste tu contraseña?</Button>

                        </Form.Group>

                        <Button
                            className="mb-1"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "Iniciando sesión..." : "Ingresar"}
                        </Button>
                    </Form>
                </Card.Body>
                <Button
                    variant="outline-secondary"
                    onClick={() => navigate("/login/socio")}
                    className="w-100"
                >
                    INGRESAR COMO SOCIO
                </Button>
            </Card>
            <Modal show={showForgotPasswordModal} onHide={() => closeForgotPasswordModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>¿Olvidaste tu contraseña?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Por favor, contacta a soporte:</p>
                        <strong>maestro.socios@kolpingchile.org</strong>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => closeForgotPasswordModal()}>
                        Cerrar
                    </Button>
                </Modal.Footer>

            </Modal>
        </Container>
    );
};

export default Login;
